import { useTranslation } from 'react-i18next'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { QA_NAME_ARROW_BUTTON } from '../../../constants/qa'
import { getVerticalIconChevronDirection, IconChevron } from '../../Icon'
import { BUTTON_HEIGHT_16 } from '../Button.constants'
import ButtonText from '../Text'

import { BUTTON_ARROW_CONTENT_ICON_PLACEMENT_BEFORE } from './ButtonArrow.constants'
import {
  getButtonArrowTooltipKey,
  isIconPlacementBeforeContent,
} from './ButtonArrow.utils'

function ButtonArrow({
  ArrowIcon = IconChevron,
  Button = ButtonText,
  closeTooltipText,
  getTooltip = getButtonArrowTooltipKey,
  height = BUTTON_HEIGHT_16,
  iconPlacement = BUTTON_ARROW_CONTENT_ICON_PLACEMENT_BEFORE,
  iconProps: buttonIconProps = EMPTY_OBJECT,
  isGrey = true,
  isGreySecondary,
  isOpen,
  openTooltipText,
  qaName = QA_NAME_ARROW_BUTTON,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.bottom,
  ...restProps
}) {
  const { t } = useTranslation()

  const buttonArrowIconProps = {
    ...buttonIconProps,
    Icon: ArrowIcon,
    iconProps: {
      ...buttonIconProps.iconProps,
      direction: getVerticalIconChevronDirection(isOpen),
    },
  }

  return (
    <Button
      {...restProps}
      {...(isIconPlacementBeforeContent(iconPlacement)
        ? {
            beforeIconProps: buttonArrowIconProps,
          }
        : { afterIconProps: buttonArrowIconProps })}
      height={height}
      isGrey={isGrey && !isGreySecondary}
      isGreySecondary={isGreySecondary}
      qaName={qaName}
      tooltip={getTooltip?.({
        closeTooltipText,
        isOpen,
        openTooltipText,
        t,
      })}
      tooltipPlacement={tooltipPlacement}
    />
  )
}

export default ButtonArrow
